import token from "../serialize-token";
export default {
    "purple-dark": {
        "purple-100-dark": token("#fbebff"),
        "purple-200-dark": token("#ecc4ff"),
        "purple-300-dark": token("#db9eff"),
        "purple-400-dark": token("#c47af4"),
    },
    "blue-dark": {
        "blue-100-dark": token("#d9f5fd"),
        "blue-200-dark": token("#94dcf7"),
        "blue-300-dark": token("#5cc1ee"),
        "blue-400-dark": token("#31a2e3"),
    },
    "light-blue-dark": {
        "light-blue-100-dark": token("#daf5fd"),
        "light-blue-200-dark": token("#97dcf4"),
        "light-blue-300-dark": token("#61c1eb"),
        "light-blue-400-dark": token("#36a2e0"),
    },
    "slate-dark": {
        "slate-100-dark": token("#ebf1f6"),
        "slate-200-dark": token("#c5d4e3"),
        "slate-300-dark": token("#a4b8cd"),
        "slate-400-dark": token("#839db4"),
        "slate-500-dark": token("#40586d"),
        "slate-600-dark": token("#293b4d"),
        "slate-700-dark": token("#1d2c3b"),
        "slate-800-dark": token("#141d28"),
        "slate-900-dark": token("#0a0e14"),
    },
    "green-dark": {
        "green-100-dark": token("#e9f5ce"),
        "green-200-dark": token("#c0dd78"),
        "green-300-dark": token("#9bc438"),
        "green-400-dark": token("#7aa809"),
    },
    "yellow-dark": {
        "yellow-100-dark": token("#feefcb"),
        "yellow-200-dark": token("#f5cd6f"),
        "yellow-300-dark": token("#e6ac28"),
        "yellow-400-dark": token("#ce8d00"),
    },
    "orange-dark": {
        "orange-100-dark": token("#ffeed2"),
        "orange-200-dark": token("#fec97a"),
        "orange-300-dark": token("#f8a433"),
        "orange-400-dark": token("#e67f01"),
    },
    "red-dark": {
        "red-100-dark": token("#ffecee"),
        "red-200-dark": token("#ffc3c9"),
        "red-300-dark": token("#ff99a1"),
        "red-400-dark": token("#fe6873"),
    },
    "berry-dark": {
        "berry-100-dark": token("#ffebf5"),
        "berry-200-dark": token("#ffc0df"),
        "berry-300-dark": token("#f69ac6"),
        "berry-400-dark": token("#e574aa"),
    },
    "gray-dark": {
        "gray-100-dark": token("#f5f6f7"),
        "gray-200-dark": token("#f0f0f0"),
        "gray-300-dark": token("#e1e1e1"),
        "gray-400-dark": token("#d2d2d2"),
        "gray-500-dark": token("#b6b6b6"),
    },
};
